import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { myDate } from "../../../../Function/dateTime";
import axios from "axios";
import { constantApp } from "../../../../config/constant";

function RecentPost() {
  const [data, setData] = useState([]);

  useEffect(() => {
    FetchData();

    return () => {
      FetchData();
    };
  }, []);

  function FetchData() {
    let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/News/ListNews.php`;
    let param = {
      isLIMIT: true,
    };

    axios.post(url, param).then((res) => {
      setData(res.data);
    });
  }

  return (
    <div className="widget recent-post-widget">
      <h3>پست های اخیر</h3>
      <ul>
        {data.map((item) => {
          return (
            <li key={item.idNews}>
              <div className="post-pic">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/assets/images/news/thumb/img-1.jpg`
                  }
                  alt=""
                  role="presentation"
                />
              </div>
              <div className="details">
                <h4 style={{ color: "#000", fontSize: 14 }}>
                  <Link
                    to={{
                      pathname: `/news/${item.idNews}`,
                      state: { from: "root" },
                    }}
                  >
                    {" "}
                    {item.Title.length < 40
                      ? `${item.Title}`
                      : `${item.Title.substring(0, 45)}...`}
                  </Link>
                </h4>
                <span style={{ float: "left", fontSize: 13, color: "gray" }}>
                  {" "}
                  {myDate(item.DateSabt)}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default RecentPost;
